import { DashboardActionTypes } from './constants';

const GET_DASHBOARD_DATA_INITIAL_STATE = {
    DashboardData: [],
    loading: false,
};

const DashboardDataReducer = (state = GET_DASHBOARD_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case DashboardActionTypes.DASHBOARD_DATA_LOADING:
            return {
                DashboardData: state.DashboardData,
                loading: true,
            };
        case DashboardActionTypes.DASHBOARD_DATA_SUCCESS:
            return {
                DashboardData: action.payload,
                loading: false,
            };
        case DashboardActionTypes.DASHBOARD_DATA_ERROR:
            return {
                DashboardData: action.payload,
                loading: false,
            };
        default:
            return state;
    }
};

export { DashboardDataReducer };
